<script setup>
import CheckboxCustomButton from "../../base/checkbox-cutom-button/index.vue";
import { computed } from "vue";

const props = defineProps({
  modelValue: Array,
});
const emits = defineEmits(["update:modelValue"]);

const checkboxValue = computed({
  get() {
    return props.modelValue;
  },
  set(val) {
    emits("update:modelValue", val);
  },
});

// "ลักษณะของครอบครัว ได้แก่
// FT1 : ครอบครัวเดี่ยว (พ่อ แม่ ลูก)
// FT2 : ครอบครัวข้ามรุ่น (ปู่ ย่า ตา ยาย อยู่กับหลานตามลำพัง)
// FT3 : ครอบครัวพ่อหรือแม่เลี้ยงเดี่ยว
// FT4 : ครอบครัววัยรุ่น (อายุต่ำกว่า 20 ปี)
// FT5 : ครอบครัวผู้สูงอายุอยู่ด้วยกันตามลำพัง 
// FT6 : ครอบครัวคู่รักเพศเดียวกัน
// FT7 : ครอบครัวผสม (ชายหญิงฝ่ายใดฝ่ายหนึ่งหรือทั้งสองฝ่าย มีบุตรติดมา)"
</script>

<template>
  <section data-test="filter-family-characteristics">
    <div class="mt-3">
      <h4 class="text-base font-normal leading-none text-theme-33">
        ลักษณะครอบครัว
      </h4>
    </div>
    <div class="flex flex-wrap mt-2">
      <CheckboxCustomButton
        id="alone-family-checkbox"
        :value="{code: 'FT1', desc: 'ครอบครัวเดี่ยว (พ่อ แม่ ลูก)'}"
        text="ครอบครัวเดี่ยว"
        class="mx-1 my-1"
        v-model="checkboxValue"
      />
      <CheckboxCustomButton
        id="skip-gen-family-checkbox"
        :value="{code: 'FT2', desc: 'ครอบครัวข้ามรุ่น (ปู่ ย่า ตา ยาย อยู่กับหลานตามลำพัง)'}"
        text="ครอบครัวข้ามรุ่น (ปู่ ย่า ตา ยาย อยู่กับหลานตามลำพัง)"
        class="mx-1 my-1"
        v-model="checkboxValue"
      />
      <CheckboxCustomButton
        id="single-dad-and-mom-checkbox"
        :value="{code: 'FT3', desc: 'ครอบครัวพ่อหรือแม่เลี้ยงเดี่ยว'}"
        text="ครอบครัวพ่อหรือแม่เลี้ยงเดี่ยว"
        class="mx-1 my-1"
        v-model="checkboxValue"
      />
      <CheckboxCustomButton
        id="teenager-family-checkbox"
        :value="{code: 'FT4', desc: 'ครอบครัววัยรุ่น (อายุต่ำกว่า 20 ปี)'}"
        text="ครอบครัววัยรุ่น (อายุต่ำกว่า 20 ปี)"
        class="mx-1 my-1"
        v-model="checkboxValue"
      />
      <CheckboxCustomButton
        id="mixed-family-checkbox"
        :value="{code: 'FT5', desc: 'ครอบครัวผู้สูงอายุอยู่ด้วยกันตามลำพัง'}"
        text="ครอบครัวผู้สูงอายุอยู่ด้วยกันตามลำพัง"
        class="mx-1 my-1"
        v-model="checkboxValue"
      />
      <CheckboxCustomButton
        id="alone-elder-family-checkbox"
        :value="{code: 'FT6', desc: 'ครอบครัวคู่รักเพศเดียวกัน'}"
        text="ครอบครัวคู่รักเพศเดียวกัน"
        class="mx-1 my-1"
        v-model="checkboxValue"
      />
      <CheckboxCustomButton
        id="lgbtq-family-checkbox"
        :value="{code: 'FT7', desc: 'ครอบครัวผสม (ชายหญิงฝ่ายใดฝ่ายหนึ่งหรือทั้งสองฝ่าย มีบุตรติดมา)'}"
        text="ครอบครัวผสม (ชายหญิงฝ่ายใดฝ่ายหนึ่งหรือทั้งสองฝ่าย มีบุตรติดมา)"
        class="mx-1 my-1"
        v-model="checkboxValue"
      />
    </div>
  </section>
</template>

<style lang="scss" scoped>
input[type="checkbox"] {
  display: none;
}
</style>
